import { SipClient } from "./sipClient";
import { LinkusSdkClient } from "./linkusSdkClient";
import { NativeSipClient } from "./nativeSipClient";
import {
  isDesktopApp,
  isElectronRuntime,
  shouldUseNativeSip,
  hasNativeTelephonyBridge,
} from "../../../utils/isDesktop";

/**
 * D2C Cloud PBX → Linkus (web and desktop).
 * Grandstream UCM → Wave Web: sip.js + WebRTC/WSS in the browser only.
 * Grandstream UCM → Wave Desktop: native SIP (UDP/TCP) via Electron + local SIP engine only.
 */
export const createSipClient = (config, handlers = {}) => {
  if (config?.providerName === "D2C_CLOUD_PBX") {
    return new LinkusSdkClient(config, handlers);
  }

  if (config?.providerName === "GRANDSTREAM_UCM") {
    if (isElectronRuntime()) {
      if (!hasNativeTelephonyBridge()) {
        throw new Error(
          "Desktop SIP engine is not available. Restart the WASL desktop app and ensure the SIP " +
            "engine is running (port 5099)."
        );
      }
      return new NativeSipClient(config, handlers);
    }
    if (isDesktopApp()) {
      throw new Error(
        "Grandstream calling runs in the WASL desktop app (native SIP). Close this browser tab " +
          "and use the Electron window from npm run dev."
      );
    }
    return new SipClient(config, handlers);
  }

  if (isElectronRuntime()) {
    throw new Error(
      "Desktop phone bridge is not loaded. Restart the Emmad Call Center desktop app " +
        "(run npm run dev:electron, not the browser tab at localhost:3000)."
    );
  }

  return new SipClient(config, handlers);
};

export const getActiveSipClientMode = (providerName) => {
  if (providerName === "D2C_CLOUD_PBX") {
    return "linkus";
  }
  if (providerName === "GRANDSTREAM_UCM") {
    return shouldUseNativeSip(providerName) ? "native-sip" : "webrtc";
  }
  return "webrtc";
};
